// =============================================================
// IMPORTS
// =============================================================
import $ from "jquery";
import { init as initFlyout } from "./modules/flyout.module.js";

if (document.querySelector(".header-swiper")) {
  import("./modules/swiperHeader.module.js").then((module) => module.init());
}

if (document.querySelector(".swiper-icon-container")) {
  import("./modules/swiperIcon.module.js").then((module) => module.init());
}

// =============================================================
// WHEN COMPLETE
// functions which are called when the page is fully loaded
// =============================================================
let attempts = 0;

const whenComplete = () => {
  if (++attempts > 30) return;

  if (document.readyState === "complete") {
    //Main menu
    initFlyout();

    if (document.querySelector("form#job-form")) {
      /* import("./modules/asJobs.module.js").then((module) => {
        module.init();
      }); */
    }

    if (document.querySelectorAll(".ctype-ce_kar_job_form").length > 0) {
      import("./modules/jobform.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelectorAll(".external-sticky").length > 0) {
      import("./modules/asJobsStickyBtn.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelectorAll("#mainmenu").length > 0) {
      import("./modules/menu.module.js").then((module) => {
        module.init();
      });
    }

    if (document.querySelectorAll("[data-inview]").length > 0) {
      import("./modules/inview.module.js").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // MD modal
    // Import and init BS5 modal module when a modal is present
    // -------------------------------------------------------------

    if (document.querySelectorAll(".modal").length > 0) {
      import("./modules/modal.module.js").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // MD Animate
    // Import and init Animate modal module when an animation is present
    // -------------------------------------------------------------
    if (document.querySelectorAll(".animate").length > 0) {
      import("./modules/animate.module.js").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // Klapper
    // -------------------------------------------------------------
    if (document.querySelectorAll(".acc__item").length > 0) {
      import("./modules/klapper.module.js").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // MD video-modal
    // Import and init video modal module when a modal for video is present
    // -------------------------------------------------------------

    if (document.getElementById("videoModal")) {
      import("./modules/videoModal.module.js").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // Lightbox
    // Lightbox for textmedia
    // -------------------------------------------------------------
    if (document.querySelector(".lightbox")) {
      import("./modules/lightbox.module.js").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // ctype-ce_kar_onecol_image_teaser
    // OneCol-Teaser
    // -------------------------------------------------------------
    if (document.querySelector(".ctype-ce_kar_onecol_image_teaser")) {
      import("./modules/onecolTeaser.module.js").then((module) => {
        module.init();
      });
    }

    // -------------------------------------------------------------
    // as-intro
    // Intro Arrow
    // -------------------------------------------------------------
    if (document.querySelector(".as_intro")) {
      import("./modules/introArrow.module.js").then((module) => {
        module.init();
      });
    }

    /*------- scroll to top ------------*/
    function updateScrollToTop() {
      if ($(window).scrollTop() > 50) {
        $("#scroll-to-top").addClass("active");
      } else {
        $("#scroll-to-top").removeClass("active");
      }
    }
    updateScrollToTop();
    $(window).on("load resize scroll", updateScrollToTop);

    /*$('.scroll-to-top').click(function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });*/
    /*------- scroll to top ------------*/

    /*------------ accordion faq ---------*/
    $(".acc .acc__head").on("click", function (e) {
      e.preventDefault();
      var $this = $(this);
      var isActive = $this.parents(".acc__item").hasClass("active");

      var $acc = $this.closest(".acc");
      if ($acc.hasClass("acc--keep-one")) {
        $acc
          .find(".acc__item.active")
          .removeClass("active")
          .find(".acc__body")
          .slideUp(500);
      }

      if (isActive) {
        $this
          .parents(".acc__item")
          .removeClass("active")
          .find(".acc__body")
          .slideUp(500);
      } else {
        $this
          .parents(".acc__item")
          .addClass("active")
          .find(".acc__body")
          .slideDown(500);
      }
    });
    /*-------- /faq ----------*/

    /*---------------- job search form -----------------*/
    /*document.getElementById("job-btn")?.addEventListener("click", function () {
      const selectedPage = document.getElementById("job-select").value;
      window.location.href = selectedPage;
    });*/
    /*---------------- /job search form -----------------*/
        /*---------sticky header---------*/
    function updateStickyHeader() {
      if (window.scrollY >= 50) {
        document.body.classList.add('sticky-header');
      } else {
        document.body.classList.remove('sticky-header');
      }
      if (window.innerWidth < 1200) {
        document.body.classList.add('sticky-header');
      }
    }
    $(window).on('resize scroll', updateStickyHeader);
    updateStickyHeader();
    /*---------/sticky header ---------*/
    /*--------- contacts bar ---------------- */
    let contactsBar = document.querySelector('.contacts-bar');
    function updateContactsBar() {
      if (!contactsBar) return;
      // console.log(document.body.scrollY);
      if (window.innerWidth >= 768) {
        if (window.pageYOffset > 50) {
          contactsBar.classList.add('contacts-bar--hidden');
        }
      }
    }

    window.addEventListener('scroll', updateContactsBar);
    /*--------- /contacts bar ---------------- */

    /*--------- custom selected option over select ---------------- */
    // Function to update the innerHTML of the corresponding .select-top__val element
    function updateSelectVal(selectElement) {
      const selectedOption =
        selectElement.options[selectElement.selectedIndex]?.innerHTML; // Safely get the selected option's innerHTML
      const selectTopVal = selectElement
        .closest(".select-top")
        ?.querySelector(".select-top__val"); // Safely find the .select-top__val
      if (selectTopVal && selectedOption) {
        selectTopVal.innerHTML = selectedOption; // Update the innerHTML of the .select-top__val
      }
    }

    document.querySelectorAll('.powermail_field [type="text"], .powermail_field [type="email"]').forEach(el => {
      el.addEventListener('focus', () => {
        el.setAttribute('data-placeholder', el.getAttribute('placeholder'))
        el.setAttribute('placeholder', '')
      })
      el.addEventListener('blur', () => {
        el.setAttribute('placeholder', el.getAttribute('data-placeholder'))
      })
    })

    // On page load, initialize the values for all select elements inside .select-top

    const selectElements = document.querySelectorAll(".select-top select"); // Get all select elements inside .select-top
    if (selectElements.length) {
      // Check if there are any select elements
      selectElements.forEach(function (selectElement) {
        updateSelectVal(selectElement); // Update value for each select on page load
      });
    }

    // Update the value when a new option is selected
    document
      .querySelectorAll(".select-top select")
      .forEach(function (selectElement) {
        selectElement.addEventListener("change", function () {
          updateSelectVal(selectElement); // Update value for each select on change
        });
      });

    /*--------- /custom selected option over select ---------------- */

    document.querySelectorAll("a.CCMopen").forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        CCM.openWidget();
      });
    });
  } else {
    setTimeout(() => whenComplete(), 400);
  }
};
whenComplete();
